export default "__VITE_ASSET__C4mw0MWO__"